import { render, staticRenderFns } from "./tagGroup.vue?vue&type=template&id=6a379dee&scoped=true&"
import script from "./tagGroup.vue?vue&type=script&lang=js&"
export * from "./tagGroup.vue?vue&type=script&lang=js&"
import style0 from "./tagGroup.vue?vue&type=style&index=0&id=6a379dee&lang=scss&scoped=true&"
import style1 from "./tagGroup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a379dee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\maixun_cxx\\private_library\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a379dee')) {
      api.createRecord('6a379dee', component.options)
    } else {
      api.reload('6a379dee', component.options)
    }
    module.hot.accept("./tagGroup.vue?vue&type=template&id=6a379dee&scoped=true&", function () {
      api.rerender('6a379dee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tagGroup.vue"
export default component.exports